<template>
  <el-switch
      v-model="readOnly"
      disabled
  >
  </el-switch>
</template>

<script>
export default {
  props: {
    readOnly: false,
  },
}
</script>

<style scoped>

</style>
